import { gsap } from "gsap";
import Draggable from "gsap/Draggable";
gsap.registerPlugin(Draggable);

// export class FeatureLogoC {
//     constructor() {
//         this.DOM = {
//             main: document.querySelector('.js-dragSlideLogos'),
//         };
//         if (!this.DOM.main) {
//             return;
//         }
//         this.DOM.container = this.DOM.main.querySelector('.js-dragSlideLogos_container');
//         this.DOM.inner = this.DOM.main.querySelector('.js-dragSlideLogos_row');
//         this.DOM.wrapper = this.DOM.main.querySelector('.container');
//         this.DOM.elements = this.DOM.main.querySelectorAll('.js-dragSlideLogos_row .logo_item');
//         this.proxy = document.createElement("div")
//         this.styles = this.DOM.elements[0].currentStyle || window.getComputedStyle(this.DOM.elements[0]);
//         this.allMargin = parseInt(this.styles.marginRight) + parseInt(this.styles.marginLeft)
//         this.direction = "to-left";
//         this.directionVal = this.direction == 'to-left' ? -1 : 1;
//         this.numBoxes  = this.DOM.elements.length;
//         this.boxWidth  = this.DOM.elements[0].offsetWidth + this.allMargin;
//         this.boxHeight = this.DOM.elements[0].offsetHeight;

//         this.viewWidth = innerWidth;
//         this.wrapWidth = this.numBoxes * this.boxWidth;
//         this.moveDistance = this.directionVal == -1 ? `-=${this.wrapWidth}` : `+=${this.wrapWidth}`

//         this.tl = gsap.timeline({
//             paused: true,
//             repeat: -1,
//         })

//         gsap.set(this.DOM.container, { height: () => this.boxHeight});
//         gsap.set(this.DOM.wrapper, { left: () => -this.boxWidth });
//         this.DOM.elements.forEach((el, i) => {
//             gsap.set(el, { x: () => i * this.boxWidth });
//         })
//         this.autoPlay();
//         this.drag();
//         this.event();
//     }
//     autoPlay() {
//         this.tl.to(this.DOM.elements, {
//             duration: 20,
//             ease: "none",
//             x: this.moveDistance,
//             modifiers: {
//                 x: gsap.utils.unitize((x) => {
//                     return (
//                         x = ((parseInt(x) - this.wrapWidth) % this.wrapWidth) + this.wrapWidth
//                     )
//                 })
//             },
//         })
//         //Autoplay
//         this.tl.play();
//     }

//     updateProgress() {
//         const wrapVal = gsap.utils.wrap(0, this.wrapWidth);
//         const wrapProgress = gsap.utils.wrap(0, 1);
//         const dragValue = (wrapVal(this.deltaX * this.directionVal) / this.wrapWidth);
//         const currentProgressAnim = this.tl.progress();
//         const endProgress = wrapProgress(currentProgressAnim + dragValue);
//         this.tl.progress(endProgress);
//     }

//     drag() {
//         Draggable.create(this.proxy, {
//             type: "x",
//             throwProps: true,
//             trigger: this.DOM.container,
//             onDrag: (delta) => {
//                 console.log(delta)
//                 const { movementX, clientX, x } = delta
//                 console.log(x)
//                 const wrapVal = gsap.utils.wrap(0, this.wrapWidth);
//                 const wrapProgress = gsap.utils.wrap(0, 1);
//                 const dragValue = (wrapVal(movementX * this.directionVal) / this.wrapWidth);
//                 const currentProgressAnim = this.tl.progress();
//                 const endProgress = wrapProgress(currentProgressAnim + dragValue);
//                 this.tl.progress(endProgress);
//             },
//             onThrowUpdate: (deltaX) => {
//                 const {movementX} = deltaX
//                 const wrapVal = gsap.utils.wrap(0, this.wrapWidth);
//                 const wrapProgress = gsap.utils.wrap(0, 1);

//                 const dragValue = (wrapVal(movementX * this.directionVal) / this.wrapWidth);
//                 const currentProgressAnim = this.tl.progress();
//                 const endProgress = wrapProgress(currentProgressAnim + dragValue);
//                 this.tl.progress(endProgress);
//             }
//         });
//     }


//     event() {
//         this.DOM.main.addEventListener("mouseenter", () => {
//             this.tl.pause()
//         });
//         this.DOM.main.addEventListener("mouseleave", () => {
//             this.tl.play()
//         });

//         window.addEventListener('resize', () => {
//             this.viewWidth = innerWidth;
//             this.styles = this.DOM.elements[0].currentStyle || window.getComputedStyle(this.DOM.elements[0]);
//             this.allMargin = parseInt(this.styles.marginRight) + parseInt(this.styles.marginLeft)
//             this.boxWidth  = this.DOM.elements[0].offsetWidth + this.allMargin;
//             this.boxHeight = this.DOM.elements[0].offsetHeight;

//             gsap.set(this.DOM.container, { height: this.boxHeight});
//             gsap.set(this.DOM.wrapper, { left: -this.boxWidth });
//             this.DOM.elements.forEach((el, i) => {
//                 gsap.set(el, { x: () => i * this.boxWidth});
//             })
//             this.tl.render(this.tl.time(), false, true);

//         })
//     }

// }

const handleFeatureLogo = () => {
    const target = [...document.querySelectorAll('.featureLogos')]

    target.forEach((el, idx) => {
        const container = el;
        const inner = el.querySelector('.js-dragSlideLogos_row');
        const wrapper = el.querySelector('.dragSlideLogos .container');
        const getAllBox = el.querySelectorAll('.js-dragSlideLogos_row .logo_item');
        const proxy    = document.createElement("div");
        let styles = getAllBox[0].currentStyle || window.getComputedStyle(getAllBox[0])
        let allMargin = parseInt(styles.marginRight) + parseInt(styles.marginLeft)
        const direction = "to-left";
        const directionVal = direction === 'to-left' ? -1 : 1;
        const numBoxes  = getAllBox.length;
        const boxWidth  = getAllBox[0].offsetWidth + allMargin;
        const boxHeight = getAllBox[0].offsetHeight;
        const wrapWidth = numBoxes * boxWidth;
        const wrapVal = gsap.utils.wrap(0, wrapWidth);
        const wrapProgress = gsap.utils.wrap(0, 1);


        gsap.set(container, { height: () => boxHeight});
        gsap.set(wrapper, { left: () => -boxWidth });
        getAllBox.forEach((box, i) => {
            gsap.set(box, { x: i * boxWidth});
        })



        const stringX = directionVal === -1 ? `-=${wrapWidth}` : `+=${wrapWidth}`;

        const animation = gsap.to(getAllBox, {
            repeat: -1,
            duration: 25,
            x: stringX,
            ease: "none",
            paused: true,
            modifiers: {
                x: function(x, target) {
                    if(directionVal === -1){
                        x = ((parseInt(x) - wrapWidth) % wrapWidth) + wrapWidth;
                    }else{
                        x = parseInt(x) % wrapWidth;
                    }
                    return `${x}px`;
                }
            }
        });


        Draggable.create(proxy, {
            type: "x",
            trigger: container,
            inertia: true,
            onDragStart: () => animation.pause(),
            onDragEnd: () => animation.play(),
            onDrag: updateProgress,
            onThrowUpdate: updateProgress
        });

        function updateProgress() {
            const dragValue = (wrapVal(this.deltaX * directionVal) / wrapWidth);
            const currentProgressAnim = animation.progress();
            const endProgress = wrapProgress(currentProgressAnim + dragValue);
            animation.progress(endProgress);
        }

        function resize() {
            styles = getAllBox[0].currentStyle || window.getComputedStyle(getAllBox[0])
            allMargin = parseInt(styles.marginRight) + parseInt(styles.marginLeft)
            const boxWidth  = getAllBox[0].offsetWidth + allMargin;
            const boxHeight = getAllBox[0].offsetHeight;
            gsap.set(container, { height: boxHeight});
            gsap.set(wrapper, { left: -boxWidth });
            animation.render(animation.time(), false, true);
        }
        window.addEventListener("resize", resize);

        container.addEventListener("mouseenter", () => animation.pause());
        container.addEventListener("mouseleave", () => animation.play());
    
        // AUTOPLAY
        animation.play();
    })
}

export default handleFeatureLogo;